function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import helper from '@/libs/helper';
import SettingMer from '@/libs/settingMer';
import { getToken } from '@/utils/auth';
export default {
  name: '',
  components: {},
  props: {
    switchIndex: {
      type: Number,
      default: 1
    },
    pid: {
      type: Number,
      default: 0
    },
    spaceId: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    breadcrumbArray: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      myHeaders: {
        authorization: 'Bearer ' + getToken()
      },
      entButton: false,
      fileUrl: '',
      uploadSize: 50,
      uploadData: {},
      type: '1',
      isSortShow: false,
      fileStyle: {
        style: 1,
        sort: 1,
        type: 1,
        keyword: '',
        sortBy: 6
      },
      newlyBuildData: [{
        name: '使用模版',
        id: 7,
        icon: ' '
      }, {
        name: '上传文件',
        id: 6,
        icon: ' iconwenjianshangchuan color-file',
        divided: true
      }, {
        name: this.$t('file.newdocument'),
        id: 1,
        icon: 'iconwendang1 color-doc',
        divided: false
      }, {
        name: this.$t('file.newtable'),
        id: 2,
        icon: 'iconbiaoge color-excel',
        divided: false
      }, {
        name: this.$t('file.newslide'),
        id: 3,
        icon: 'iconppt color-ppt',
        divided: false
      }, {
        name: this.$t('file.newfolder'),
        id: 5,
        icon: 'iconwenjianjia color-file',
        divided: true
      }],
      fileSortData: [{
        name: this.$t('file.filename'),
        id: 1
      }, {
        name: this.$t('file.creationtime'),
        id: 2
      }, {
        name: this.$t('file.updatetime'),
        id: 3
      }, {
        name: this.$t('file.filesize'),
        id: 4
      }, {
        name: this.$t('file.deletetime'),
        id: 5
      }],
      fileSort: [{
        name: this.$t('file.order'),
        id: 6
      }, {
        name: this.$t('file.desc'),
        id: 7
      }],
      fileScreenData: [{
        name: this.$t('file.type'),
        id: 1
      }, {
        name: this.$t('file.document'),
        id: 2
      }, {
        name: this.$t('file.ppt'),
        id: 3
      }, {
        name: this.$t('file.picture'),
        id: 4
      }, {
        name: this.$t('file.table'),
        id: 5
      }]
    }, "newlyBuildData", [{
      name: '使用模版',
      id: 7,
      icon: ' '
    }, {
      name: '上传文件',
      id: 6,
      icon: ' iconwenjianshangchuan color-file',
      divided: true
    }, {
      name: this.$t('file.newdocument'),
      id: 1,
      icon: 'iconwendang1 color-doc',
      divided: false
    }, {
      name: this.$t('file.newtable'),
      id: 2,
      icon: 'iconbiaoge color-excel',
      divided: false
    },
    // { name: this.$t('file.newslide'), id: 3, icon: 'iconppt color-ppt', divided: false },
    {
      name: this.$t('file.newfolder'),
      id: 5,
      icon: 'iconwenjianjia color-file',
      divided: true
    }]), "screenIndex", 1), "screenName", ''), "typeValue", 1), "sortIndex", 1), "sortValue", 0), "sortName", ''), "typeName", '');
  },
  watch: {
    spaceId: {
      handler: function handler(nVal, oVal) {
        if (this.switchIndex == 6 || this.switchIndex == 1) {
          this.typeValue = 1;
          // this.$emit('formBoxClick', 'handleType', 1)
          this.fileUrl = SettingMer.https + "/cloud/file/".concat(this.spaceId, "/upload");
        } else {
          this.fileUrl = SettingMer.https + "/folder/upload";
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    this.sortName = this.fileSortData[this.sortIndex - 1].name;
  },
  methods: {
    allMove: function allMove() {
      this.$emit('formBoxClick', 'allMove');
    },
    allDelete: function allDelete(val) {
      this.$emit('formBoxClick', 'allDelete', val);
    },
    handleClick: function handleClick(e) {
      this.$emit('formBoxClick', 'handleClick', e);
    },
    handleScreen: function handleScreen(e) {
      if (e === 6) return false;
      this.$emit('formBoxClick', 'handleScreen', e);
    },
    getBreadcrumb: function getBreadcrumb(pid, index) {
      this.$emit('formBoxClick', 'getBreadcrumb', pid, index);
    },
    getStyle: function getStyle() {
      this.$emit('formBoxClick', 'styleChage', this.fileStyle);
    },
    handleType: function handleType(command) {
      this.typeValue = command;
      this.$emit('formBoxClick', 'handleType', command);
    },
    // 排序
    handleSort: function handleSort(index, id) {
      this.sortValue = index;
      this.fileStyle.sortBy = id;
      this.isSortShow = false;
      this.$emit('handleSort', index, id);
    },
    handleCommand: function handleCommand(command) {
      this.isSortShow = false;
      this.sortName = this.fileSortData[command - 1].name;
      this.sortIndex = command;
      this.fileStyle.sort = command;
      this.$emit('handleCommand', command);
    },
    handleSortShow: function handleSortShow() {
      this.isSortShow = !this.isSortShow;
    },
    handleFileStyle: function handleFileStyle(e) {
      this.fileStyle.style = e;
      this.$emit('formBoxClick', 'styleChage', this.fileStyle, 'unChange');
    },
    // 回收站
    recoveryBtn: function recoveryBtn() {
      this.entButton = true;
      this.$emit('formBoxClick', 'recoveryBtn');
    },
    // 返回企业空间
    returnSpace: function returnSpace() {
      this.$emit('formBoxClick', 'returnSpace');
    },
    // 上传成功
    handleSuccess: function handleSuccess(response) {
      this.$emit('isUploaded');
      this.$emit('formBoxClick', 'handleSuccess', response);
    },
    // 上传前
    handleUpload: function handleUpload(file, item) {
      var types = helper.uploadTypes;
      this.uploadData.pid = this.pid;
      var fileTypeName = file.name.substr(file.name.lastIndexOf('.') + 1);
      var isImage = types.includes(fileTypeName.toLowerCase());
      var isLtSize = file.size / 1024 / 1024 < this.uploadSize;
      if (!isImage) {
        this.$message.error('仅支持 ' + types.join(',') + ' 格式');
        return false;
      }
      if (!isLtSize) {
        this.$message.error('上传文件、图片大小不能超过 ' + this.uploadSize + ' MB!');
        return false;
      }
      this.$emit('isUploading');
      return true;
    }
  }
};